// extracted by mini-css-extract-plugin
export default {"l_BabyInfoInputContainer_InputContainer":"BabyInfoInputContainer_l_BabyInfoInputContainer_InputContainer__H-gZj"};